import { useSyncExternalStore } from 'react';
import { assinarIdioma, idiomaAtual, type Idioma } from './idioma';

/**
 * Redesenha o componente quando o idioma muda. O texto continua vindo de `t()`
 * — este hook só existe para o React saber que precisa redesenhar.
 */
export function useIdioma(): Idioma {
  return useSyncExternalStore(assinarIdioma, idiomaAtual, () => idiomaAtual());
}
